import {Directive, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NG_VALIDATORS, Validator, AbstractControl} from '@angular/forms';

// tslint:disable-next-line:max-line-length
const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Directive({
    selector: '[jhiEmail][ngModel]',
    providers: [
        {provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true}
    ]
})
export class EmailValidatorDirective implements Validator, OnChanges {

    @Input()
    matchTo: string;

    private onChange: () => void;

    validate(c: AbstractControl): { [key: string]: any; } {

        if (!c.value) {
            return null;
        }

        if (this.matchTo && this.matchTo !== c.value) {
            return {'invalid-confirmaton-email': true};
        }

        if (!c.value.match(EMAIL_PATTERN)) {
            return {'invalid-email': true};
        }

        return null;
    }

    registerOnValidatorChange(fn: () => void): void {
        this.onChange = fn;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('matchTo' in changes && this.onChange) {
            this.onChange();
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/validators/email-validator.ts